export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-en@2x-d7f8f86d19effa35b9b398e0e65f9ad7.png";